// ThemeGrid.tsx
type ThemeGridProps = {
  children: React.ReactNode;
  columns?: 1 | 2 | 3 | 4;
  gap?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  rowGap?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'; // Separate row gap
  colGap?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'; // Separate column gap
  className?: string;
};

const gridColumns = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 md:grid-cols-2',
  3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
};

const gapClasses = {
  none: 'gap-0',
  xs: 'gap-1',
  sm: 'gap-4',
  md: 'gap-6',
  lg: 'gap-8',
  xl: 'gap-12',
  '2xl': 'gap-16'
};

const rowGapClasses = {
  none: 'gap-y-0',
  xs: 'gap-y-1',
  sm: 'gap-y-4',
  md: 'gap-y-6',
  lg: 'gap-y-8',
  xl: 'gap-y-12',
  '2xl': 'gap-y-16'
};

const colGapClasses = {
  none: 'gap-x-0',
  xs: 'gap-x-1',
  sm: 'gap-x-4',
  md: 'gap-x-6',
  lg: 'gap-x-8',
  xl: 'gap-x-12',
  '2xl': 'gap-x-16'
};



export const ThemeGrid: React.FC<ThemeGridProps> = ({ 
  children, 
  columns = 2, 
  gap = 'md',
  rowGap,
  colGap,
  className = ''
}) => {
    const gapClass = gap !== undefined ? gapClasses[gap] : '';
    const rowClass = rowGap !== undefined ? rowGapClasses[rowGap] : '';
    const colClass = colGap !== undefined ? colGapClasses[colGap] : '';
  
  return (
    <div className={`grid ${gridColumns[columns]} ${gapClass} ${rowClass} ${colClass} ${className}`}>
      {children}
    </div>
  );
};